/**
 * 品目名の表記ゆれ対応マップ。
 * キー = 正規化名、値 = 別表記の配列。
 * データ取得時にキーと全候補を試行する。
 */
export const ITEM_ALIASES: Record<string, string[]> = {
  中華麺: ["中華めん"],
  カップ麺: ["カップめん"],
  めん類: ["麺類"],
};

/** 表記を正規化名に変換する。対応がなければ元の名前をそのまま返す。 */
export function normalizeItemName(raw: string): string {
  for (const [canonical, aliases] of Object.entries(ITEM_ALIASES)) {
    if (raw === canonical || aliases.includes(raw)) {
      return canonical;
    }
  }
  return raw;
}
